module.exports = __webpack_public_path__ + "img/power-by.0fe1aab0.png";